/**
 * Deterministic colour palettes for directory cards.
 *
 * Every "colourful card" (family trees, memorials, causes, pulse items)
 * pulls its palette from `paletteFor(key)` where `key` is the card's
 * slug or id. Same key → same palette on every render, different keys →
 * visually distinct neighbours in a grid.
 *
 * Exported so multiple directory pages can share one palette contract.
 */

export const CARD_PALETTES = [
  { from: "#FEF3C7", to: "#FDE68A", accent: "#B25D38", ink: "#7C3F00" }, // warm amber
  { from: "#DBEAFE", to: "#BFDBFE", accent: "#1E40AF", ink: "#1E3A8A" }, // sky blue
  { from: "#DCFCE7", to: "#BBF7D0", accent: "#166534", ink: "#14532D" }, // sage green
  { from: "#FCE7F3", to: "#FBCFE8", accent: "#9D174D", ink: "#831843" }, // rose
  { from: "#EDE9FE", to: "#DDD6FE", accent: "#5B21B6", ink: "#4C1D95" }, // violet
  { from: "#CFFAFE", to: "#A5F3FC", accent: "#155E75", ink: "#164E63" }, // teal
  { from: "#FFEDD5", to: "#FED7AA", accent: "#9A3412", ink: "#7C2D12" }, // sunset
  { from: "#E0E7FF", to: "#C7D2FE", accent: "#3730A3", ink: "#312E81" }, // indigo
  { from: "#FEE2E2", to: "#FECACA", accent: "#991B1B", ink: "#7F1D1D" }, // clay
  { from: "#F5F3FF", to: "#E9D5FF", accent: "#6D28D9", ink: "#5B21B6" }, // lilac
];

export function paletteFor(key) {
  const s = String(key || "");
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return CARD_PALETTES[h % CARD_PALETTES.length];
}
